import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

/**
 * Upload a building photo (optionally already compressed client-side).
 * Stored under property-media for authenticated users.
 * @param {string} propertyId
 * @param {File} file
 * @returns {Promise<string>} download URL
 */
export async function uploadPropertyBuildingImage(propertyId, file) {
  if (!propertyId || !file) throw new Error('propertyId and file required');
  const rawName = (file.name || 'photo.jpg').replace(/[^a-zA-Z0-9._-]/g, '_');
  const path = `property-media/${propertyId}/building/${Date.now()}-${rawName}`;
  const storageRefPath = ref(storage, path);
  await uploadBytes(storageRefPath, file);
  return getDownloadURL(storageRefPath);
}
